import { TabPanel, TabView } from "primereact/tabview";
import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Dashboard components
import MDBox from "components/MDBox";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Store
import { getDppIds, getSubModulesByRoleId } from "../../store";

// Modules
import Passport from "./CALSTW";
import CareAndUseInstructions from "./Care&UseInstructions";
import ChemicalAnalysis from "./ChemicalAnalysis";
import Compliance from "./compliance";
import Custody from "./custody";
import Documents from "./documents-dpp";
import Durability from "./durability";
import FGOPERATIONLOG from "./fgOperation";
import Packaging from "./IALSTW";
// import IndustryMaster from "./Industry-master";
import ProductTestingMaster from "./ProductTestingMaster";
import RepairValue from "./Repair-Value";
import Returns from "./returns";
import RmTraceability from "./RmTraceability";
import UsageHistory from "./usage-history";

import Select from "react-select";

// Cookies
import MDTypography from "components/MDTypography";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const allModules = [
  {
    key: "passportModule",
    moduleId: "14087f18-c281-4ed7-9f1a-c1b627b50f8e",
    component: Passport,
    label: "Passport",
  },
  {
    key: "packagingModule",
    moduleId: "7e02c688-4e21-4805-9f51-2320dda92382",
    component: Packaging,
    label: "Packaging",
  },
  {
    key: "repairValueModule",
    moduleId: "9f3b7cf0-eb97-4567-8d4a-711868269662",
    component: RepairValue,
    label: "Repair Value",
  },
  {
    key: "returnsModule",
    moduleId: "6e1939a2-039d-4a29-8e00-728b8bfed0aa",
    component: Returns,
    label: "Returns",
  },
  {
    key: "custodyModule",
    moduleId: "269b317f-3fc3-4ce8-b885-0817acf36a66",
    component: Custody,
    label: "Custody",
  },
  {
    key: "complianceModule",
    moduleId: "013a3276-d1db-4051-b489-b199b4710cf4",
    component: Compliance,
    label: "Compliance",
  },
  {
    key: "documentsModule",
    moduleId: "b3605909-30dc-4c9f-8918-f1ef34354fd2",
    component: Documents,
    label: "Documents",
  },
  {
    key: "durabilityModule",
    moduleId: "5e690abe-d7a1-4e45-8782-43409b4edab2",
    component: Durability,
    label: "Durability",
  },
  {
    key: "rmItemsModule",
    moduleId: "852fd581-2cd9-40d1-b0f6-e29dd61566ff",
    component: RmTraceability,
    label: "RM Items",
  },
  {
    key: "productionModule",
    moduleId: "3a6c5d90-c26f-45c5-9294-3dd13df1b2d5",
    component: FGOPERATIONLOG,
    label: "Production",
  },

  {
    key: "productTestingModule",
    moduleId: "16cc0217-cbce-4e3f-874b-89b3fbdd0232",
    component: ProductTestingMaster,
    label: "Product Testing",
  },

  // {
  //   key: "manufacturerModule",
  //   moduleId: "d51e5caa-b714-4739-877a-3b78d6f9d263",
  //   component: manufacturer,
  //   label: "Manufacturer",
  // },

  {
    key: "ChemicalAnalysisModule",
    moduleId: "80f14403-a4be-4883-9534-b4c9ed6aaeb8",
    component: ChemicalAnalysis,
    label: "Chemical Analysis",
  },
  {
    key: "CareAndUseInstructionsModule",
    moduleId: "80f14403-a4be-4883-9534-b4c9ed6aaeb8",
    component: CareAndUseInstructions,
    label: "Care & Use Instructions",
  },
  {
    key: "Usage History",
    moduleId: "80f14403-a4be-4883-9534-b4c9ed6aaeb8",
    component: UsageHistory,
    label: "Usage History",
  },
  // {
  //   key: "CareAndUseInstructionsModule",
  //   moduleId: "80f14403-a4be-4883-9534-b4c9ed6aaeb8",
  //   component: IndustryMaster,
  //   label: "Industry Master",
  // },
  // {
  //   key: "Supplier Information",
  //   moduleId: "80f14403-a4be-4883-9534-b4c9ed6aaeb8",
  //   component: SupplierInformation,
  //   label: "Supplier Information",
  // }
  ,
];

const DbbSystemParent = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getDppIds,
  getDPPReducer,
}) => {
  const loginDetails = cookies.get("loginDetailsForWMS");
  const jwtToken = loginDetails?.jwt;
  const roleId = loginDetails?.data?.roleId;

  const [modulesAccess, setModulesAccess] = useState({});
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (roleId && jwtToken) getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId, jwtToken, getSubModulesByRoleId]);

  useEffect(() => {
    const modulesData =
      getSubModulesByRoleIdReducer?.subModulesByRoleData?.data || [];
    const access = {};

    allModules.forEach((mod) => {
      access[mod.key] = modulesData.some((m) => m.moduleId === mod.moduleId);
    });

    setModulesAccess(access);
  }, [getSubModulesByRoleIdReducer]);

  useEffect(() => {
    getDppIds(jwtToken);
  }, []);

  const [dppIdSelectedForGlobalFilter, setdppIdSelectedForGlobalFilter] =
    useState("");

  // console.log("dppIdSelectedForGlobalFilter", dppIdSelectedForGlobalFilter)
  const handleChangeDpp = (selectedData) => {
    setdppIdSelectedForGlobalFilter(selectedData);
  };

  const [dppOptions, setDPPOptions] = useState([]);

  useEffect(() => {
    let tempgetDPPReducer = [];
    let data = getDPPReducer.dpp.data ? getDPPReducer.dpp.data : [];

    data.map((zone) => {
      tempgetDPPReducer.push({
        label: zone.dppCode,
        value: zone.dppId,
        industryId: zone.industryId,
      });
    });
    setDPPOptions(tempgetDPPReducer);
  }, [getDPPReducer]);

  const activeModules = allModules.filter((mod) => modulesAccess[mod.key]);
  const hasAccess = activeModules.length > 0;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        sx={{
          width: "100%",
          minHeight: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* FILTER BAR */}
        <MDBox
          sx={{
            flexShrink: 0,
            backgroundColor: "#fff",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <MDBox
            sx={{
              maxWidth: "1600px",
              mx: "auto",
              px: 3,
              py: 2,
              pt: 6,
            }}
          >
            <MDTypography sx={{ fontWeight: 600, fontSize: "15px", mb: 1 }}>
              DPP/Product Code
            </MDTypography>

            <MDBox display="flex" alignItems="center" gap={2}>
              <MDBox sx={{ width: 360, maxWidth: "100%" }}>
                <Select
                  isClearable
                  className="select-css-for-filter"
                  placeholder="Choose One..."
                  value={dppIdSelectedForGlobalFilter}
                  options={dppOptions}
                  onChange={handleChangeDpp}
                  maxMenuHeight={380}
                  styles={{
                    container: (base) => ({
                      ...base,
                      width: "100%",
                      zIndex: 1111,
                    }),
                    control: (base) => ({
                      ...base,
                      minHeight: 36,
                      fontSize: "16px",
                    }),
                  }}
                />
              </MDBox>
            </MDBox>
          </MDBox>
        </MDBox>

        {/* CONTENT */}
        <MDBox
          sx={{
            flex: 1,
            overflow: "hidden",
          }}
        >
          {hasAccess ? (
            <TabView style={{ height: "100%" }} activeIndex={activeIndex}>
              {activeModules.map((mod) => (
                <TabPanel key={mod.key} header={mod.label}>
                  <mod.component
                    dppIdSelectedForGlobalFilter={dppIdSelectedForGlobalFilter}
                    // filterErrorLogBy={mod.key === "Upload Error Log" ? filterErrorLogBy : undefined}
                  />
                </TabPanel>
              ))}
            </TabView>
          ) : (
            <MDTypography sx={{ textAlign: "center", mt: 6 }}>
              No Module Access
            </MDTypography>
          )}
        </MDBox>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => ({
  getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  getDPPReducer: state.getDPPReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getSubModulesByRoleId: (roleId, jwtToken) =>
    dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  getDppIds: (jwtToken) => dispatch(getDppIds(jwtToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DbbSystemParent);
